import React from 'react';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import { ReviewSubjectDto } from '@interfaces-clean/subject-monitoring/subject-review';
import SubjectsOnReviewGrid from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/subjects-on-review-grid';

type Props = {
    studyRef: string;
    review: EditReviewDto;
    reviewSubjects: ReviewSubjectDto[];
};

const SMSelectedReviewSectionSubjectTab = ({ studyRef, review, reviewSubjects }: Props) => {
    return <SubjectsOnReviewGrid canEdit={false} studyRef={studyRef} review={review} reviewSubjects={reviewSubjects} />;
};

export default SMSelectedReviewSectionSubjectTab;
